export const LayoutActionTypes = {
  OPEN_LEFT_MENU: '@@layout/OPEN_LEFT_MENU',
  CLOSE_LEFT_MENU: '@@layout/CLOSE_LEFT_MENU',
  LOCK_NAVIGATION: '@@layout/LOCK_NAVIGATION',
  UNLOCK_NAVIGATION: '@@layout/UNLOCK_NAVIGATION',
};
